import { useQuery } from 'react-query';
import { getProviders } from 'services/provider.service';
import { AxiosResponse } from 'axios';

export const getProvidersQueryKey = 'getProviders';

export const useProviders = () => useQuery([getProvidersQueryKey], () => getProviders()
  .then((result: AxiosResponse<string[]>) => result.data), { refetchOnWindowFocus: false, retry: false });
